export const printContent = (elementId) => { 
    let printContents = elementId.innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
   document.body.innerHTML = originalContents;
   window.location.reload() 
}